import apiClient from './client';
import { StoreSettings } from '../types/admin';

export const fetchStoreSettings = async (): Promise<StoreSettings> => {
  const { data } = await apiClient.get<StoreSettings>('/appmanage/settings');
  return data;
};

export interface UpdateStoreSettingsPayload {
  openTime: string;
  closeTime: string;
  isTempClosed: boolean;
  tempClosedReason: string;
  defaultWaitMinutes: number;
  minOrderAmount: number;
}

export const updateStoreSettings = async (payload: UpdateStoreSettingsPayload): Promise<void> => {
  await apiClient.put('/appmanage/settings', payload);
};
